<!-- Show router-outlet only when not authenticating -->
<router-outlet *ngIf="isLoginCompletedSuccessfully"></router-outlet>

<!-- custom loader -->
<div *ngIf="preLoader" class="spinner-container-wrapper">
  <div class="spinner-container">
    <mat-spinner class="custom-spinner"></mat-spinner>
  </div>
</div>

<ng-template #SignalRModalPopup>
  <div class="col-12 p-0">
    <!-- <form class=""> -->
    <div class="cmn-signalr-popup-container">
      <div class="cmn-modal-header">
        <h4 class="modal-header-title">
          <img src="../../../assets/img/invoiceSummary/information icon.svg" />
          {{SignalRTitle}}
        </h4>
      </div>
      <div class="cmn-modal-content">
        <p>
          <span *ngFor="let messageStatement of getSignalRMessageStatements()" class="signalr-message-line">
            {{messageStatement}}
          </span>
        </p>
      </div>
      <div class="cmn-modal-footer">
        <button type="button" mat-button class="cmn-blue-btn" (click)="modalpopupClose()">Ok</button>
      </div>
    </div>
    <!-- </form> -->
  </div>
</ng-template>

<ng-template #ErrorModalPopup>
  <div class="col-12 p-0">
    <div class="cmn-signalr-popup-container">
      <div class="cmn-modal-header">
        <h4 class="modal-header-title">
          <img src="../../../assets/img/invoiceSummary/information icon.svg" />
          {{ErrorTitle}}
        </h4>
      </div>
      <div class="cmn-modal-content">
        <p>
          {{ErrorMessage}}
        </p>
      </div>
      <div class="cmn-modal-footer">
        <button type="button" mat-button class="cmn-blue-btn" (click)="errormodalpopupClose()">Ok</button>
      </div>
    </div>
  </div>
</ng-template>
